import React from "react";
import { useState } from "react";
import { Container, Row , Col, Card, Button, Spinner} from "react-bootstrap";
import '../estilos/Bienvenida.css';
import axios from "axios";




function ReporteTotales (props) {

    const [loading, setLoading] = useState(false);

   const DescargarReporte = async (token) => {
    try {
      setLoading(true); // activar loading
      const response = await axios({
        url: "api/get_reporte_totales",
        method: "POST",
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "reporte_totales.xlsx");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error("Error al descargar:", err);
    } finally {
      setLoading(false); // desactivar loading
    }
  };

    return (
    <>
    <Container className="contenedor-card" >
        <Row ></Row>
        <Row><Col>
        <Card>
        <Card.Header><span className="letras-negras">
            Reportes de Totales
            </span>
            </Card.Header>
        <Card.Body>
            <Card.Title><span className="letras-negras">SISTEMA GESTIÓN LABORATORIO</span></Card.Title>
            <Card.Text>
                {/*<a href="#" onClick={(e) => {e.preventDefault(); DescargarReporte(props.token);}}>Descargar reporte de totales</a>*/}
                <Button
                  variant="primary"
                  onClick={() => DescargarReporte(props.token)}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Generando reporte...
                    </>
                  ) : (
                    "Descargar reporte de totales"
                  )}
                </Button>
            </Card.Text>
        </Card.Body>
        </Card></Col>
        </Row>
    </Container>
    </>
    )
}

export default ReporteTotales;